import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ViewEncapsulation,
  ViewChild,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { Observable } from "rxjs";
import { ReportingPagesDataService } from "./../reporting-pages-data.service";
import { ReportingPagesService } from "./../reporting-pages.service";
import { AntGridCustomComponent } from "../../ant-grid-custom/ant-grid-custom.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { CommonModalService } from "../../shared/common-modal/common-modal.service";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { NzModalRef } from "ng-zorro-antd/modal";
@Component({
  selector: "app-reporting-grid-wrapper",
  templateUrl: "./reporting-grid-wrapper.component.html",
  styleUrls: ["./reporting-grid-wrapper.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: "reporting-wrapper-component" },
})
export class ReportingGridWrapperComponent implements OnInit {
  @Input() page: string;
  @Input() columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
    setWidth?: boolean;
    columnVisiblityChange?: boolean;
  };
  @Input() gridUrl: string;
  @Input() showGridFilters: boolean;
  @Input() sortKey: string;
  @Input() sortOrder?: string;
  @Input() globalSearchVal: string;
  @Input() selectedWatchlistId: number;
  @Input() dataCovTypeId: number;
  @ViewChild(AntGridCustomComponent)
  antGridComp: AntGridCustomComponent;
  dataToUse: {};
  columnFields: Array<Dictionary<any>>;
  columnsData: Array<any>;
  processedData: Dictionary<any> = {};
  totalResultCount: number;
  pageIndex = 1;
  pageSize = 24;
  sortObj: Dictionary<any>;
  dataObservable: Observable<any | any>;
  showFilter = false;
  errorMsg = "Something went wrong!";
  appliedFilter: {};
  initialParams: {};
  faExclamationTriangle = faExclamationTriangle;
  ignoreGlobalSearchClear = false;

  constructor(
    private dataService: ReportingPagesDataService,
    private service: ReportingPagesService,
    private activatedRoute: ActivatedRoute,
    private modalService: CommonModalService,
    private router: Router,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.totalResultCount = 0;
    this.appliedFilter = {};
    this.sortObj = {
      key: this.sortKey,
      value: this.sortOrder !== undefined ? this.sortOrder : "asc",
    };
    const params = {
      baseUrl: this.gridUrl,
      pageIndex: this.pageIndex,
      sortOrder: this.sortObj.value,
      sortKey: this.sortObj.key,
      pageSize: this.pageSize,
      page: this.page,
      filters: [],
      globalSearch: this.globalSearchVal,
    };
    if (this.dataCovTypeId !== void 0) {
      params["dataCovTypeId"] = this.dataCovTypeId;
    }
    this.initialParams = { ...params };
    this.dataObservable = this.dataService.getReportGridData(params);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.columns && changes.columns.currentValue) {
      this.columnFields = this.columns.columnFields;
      this.columnsData = this.columns.columnsData;
      this.appliedFilter = {};
      this.pageIndex = 1;
      if (!changes.columns.firstChange) {
        if (changes.columns.currentValue.columnVisiblityChange) {
          this.reloadGrid();
        } else if (
          JSON.stringify(changes.columns.previousValue) !==
          JSON.stringify(changes.columns.currentValue)
        ) {
          this.callForGridData();
        }
      }
    }
    if (changes.showGridFilters && !changes.showGridFilters.firstChange) {
      this.showFilter = this.showGridFilters;
      //reduce height or increse height based on showFilter
      const gridHt = this.setHeight();
      this.dataToUse = {
        ...this.dataToUse,
        showInternalFilters: this.showFilter,
        gridHeight: gridHt, // height calculated as per screen height - top
      };
    }
    if (
      (changes.globalSearchVal &&
        changes.globalSearchVal.currentValue !== undefined) ||
      (changes.selectedWatchlistId &&
        changes.selectedWatchlistId.currentValue !== undefined &&
        changes.selectedWatchlistId.currentValue !== "") ||
      (changes.dataCovTypeId &&
        changes.dataCovTypeId.currentValue !== undefined &&
        changes.dataCovTypeId.currentValue !== "")
    ) {
      this.pageIndex = 1;
      this.callForGridData();
    }

    if (changes.gridUrl && changes.gridUrl.currentValue !== undefined) {
      if (this.initialParams && this.initialParams["baseUrl"])
        this.initialParams["baseUrl"] = changes.gridUrl.currentValue;
      if (this.antGridComp) this.antGridComp.resetAll();
      this.appliedFilter = {};
      this.globalSearchVal =
        changes.globalSearchVal &&
        changes.globalSearchVal.currentValue !== undefined
          ? this.globalSearchVal
          : "";
      if (this.initialParams) {
        this.dataObservable = this.dataService.getReportGridData(
          this.initialParams,
        );
      }
    }
  }
  onDataResolved(response) {
    if (response.status === "error") {
      this.processedData = [];
      this.totalResultCount = 0;
      if (response.not_entitled) {
        this.showDeleteAlertModal();
      }
    } else {
      this.processedData = this.getProcessedData(response);
      this.totalResultCount = response.records;
    }
    this.dataToUse = {
      showCheckbox: false,
      showCheckboxHeader: false,
      columnsData: this.columnsData,
      fields: this.columnFields,
      processedData: this.processedData,
      selectedRows: null,
      totalCount: this.totalResultCount,
      widthConfig: this.columns.widthConfig,
      gridHeight: this.setHeight(), // height calculated as per screen height - top
      gridWidth: "auto",
      bordered: false,
      showInternalFilters: this.showFilter,
      pageSize: this.pageSize,
      pageSizeOptions: [12, 24, 48, 96],
      pageIndex: this.pageIndex,
      showTotalCount: true,
    };
    if (this.columns.setWidth) {
      const gridWidths = this.columns.widthConfig.map((a) => {
        return parseInt(a);
      });
      const gridWidth = gridWidths.reduce((a, b) => {
        return a + b;
      }, 0);
      this.dataToUse["gridWidth"] = `${gridWidth.toString()}px`;
    }
  }
  getProcessedData(data) {
    let processedData = {};

    switch (this.page) {
      case "allbrokers":
        processedData = this.service.getAllBrokersData(data);
        break;
      case "broker":
        processedData = this.service.getBrokerData(data);
        break;
      case "sector":
        processedData = this.service.getSectorData(data);
        break;
      case "industry":
        processedData = this.service.getIndustryData(data);
        break;
      case "analyst":
        processedData = this.service.getAnalystData(data);
        break;
      case "allcompany":
        processedData = this.service.getAllCompanyData(data);
        break;
      case "models":
        processedData = this.service.getAllModelData(data);
        break;
      default:
        break;
    }
    return processedData;
  }
  getNextPageData(pageIndex: number, pageSize: number) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.callForGridData();
  }
  onSortChange(sortData: Dictionary<any>) {
    this.sortObj = sortData;
    this.sortObj.value =
      sortData.value === "ascend" || sortData.value === "asc" ? "asc" : "desc";
    this.callForGridData();
  }
  filterApplied(value, columnData) {
    if (value === "") {
      delete this.appliedFilter[columnData.sortKey];
      this.callForGridData();
      return;
    }
    const currentFilter = {
      field: columnData.sortKey,
      op: columnData.filterType === "select" ? "eq" : "cn",
      data: encodeURIComponent(value),
    };
    if (!this.appliedFilter[columnData.sortKey]) {
      this.appliedFilter[columnData.sortKey] = {};
    }
    this.appliedFilter[columnData.sortKey] = currentFilter;
    this.pageIndex = 1;
    this.callForGridData();
  }

  gridReload() {
    this.gridUrl = this.initialParams["baseUrl"];
    this.pageIndex = this.initialParams["pageIndex"];
    this.sortObj.value = this.initialParams["sortOrder"];
    this.sortObj.key = this.initialParams["sortKey"];
    this.pageSize = this.initialParams["pageSize"];
    this.page = this.initialParams["page"];
    this.appliedFilter = {};
    this.globalSearchVal = "";
    if (this.dataCovTypeId !== void 0) {
      this.dataCovTypeId = 1;
    }
    this.antGridComp.resetAll();
    // this.antGridComp.sort({key: this.sortObj.key, value: this.sortObj.value});
    this.callForGridData();
  }

  callForGridData() {
    if (!this.sortObj) {
      return;
    }
    if (this.ignoreGlobalSearchClear && this.globalSearchVal === "") {
      this.ignoreGlobalSearchClear = false;
      return;
    }
    this.antGridComp && this.antGridComp.isLoading();
    const params = {
      baseUrl: this.gridUrl,
      pageIndex: this.pageIndex,
      sortOrder: this.sortObj && this.sortObj.value,
      sortKey: this.sortObj && this.sortObj.key,
      pageSize: this.pageSize,
      page: this.page,
      filters: Object.values(this.appliedFilter),
      columns: this.columnFields,
      globalSearch: this.globalSearchVal,
    };
    if (this.selectedWatchlistId) {
      params["watchlist_id"] = this.selectedWatchlistId;
    }
    if (this.dataCovTypeId !== void 0) {
      params["dataCovTypeId"] = this.dataCovTypeId;
    }
    this.dataService.getReportGridData(params).subscribe(
      (response) => {
        this.onDataResolved(response);
      },
      (err) => {
        console.error(err);
      },
    );
  }

  reloadGrid() {
    if (!this.sortObj) {
      return;
    }
    this.antGridComp && this.antGridComp.isLoading();
    if (this.columns.setWidth) {
      const gridWidths = this.columns.widthConfig.map((a) => {
        return parseInt(a);
      });
      const gridWidth = gridWidths.reduce((a, b) => {
        return a + b;
      }, 0);
      // if some column has auto width, then gridWidth comes out as NaN, it happens when
      // very few columns are selected in reporting/models page, then last column has auto width.
      this.dataToUse["gridWidth"] = Number.isNaN(gridWidth)
        ? "auto"
        : `${gridWidth.toString()}px`;
    }
    this.dataToUse = {
      ...this.dataToUse,
      columnsData: this.columnsData,
      fields: this.columnFields,
      processedData: this.processedData,
      widthConfig: this.columns.widthConfig,
      showInternalFilters: this.showFilter,
    };
  }
  setHeight() {
    const pagesWithMoreHt = ["sector", "industry", "allcompany", "allbrokers"];
    let minusHt = pagesWithMoreHt.includes(this.page) ? 316 : 496;

    if (this.page === "analyst") {
      minusHt = 416;
    }
    if (this.page === "models") {
      minusHt = 348;
    }
    if (this.page === "broker") {
      minusHt = 408;
    }
    if (this.showFilter) {
      minusHt = minusHt + 29;
    }
    const gHeight = `calc(100vh - ${minusHt}px)`;
    return gHeight;
  }
  handleFailure(err) {
    if (err && err[0] && err[0].not_entitled) {
      this.showDeleteAlertModal();
    }
  }

  showDeleteAlertModal = (): void => {
    const title = `Not Entitled`;
    const message = `<b>
        You are currently not entitled to this content.<br/>
      </b>
      Questions? Contact 
      <a href="mailto:support@visiblealpha.com">support@visiblealpha.com</a>
    `;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ff4e33",
      icon: faExclamationTriangle as IconDefinition,
      actionPrimaryText: "Close",
      onPrimaryClick: primaryAction,
    };

    modal = this.modalService.create(modalOptions);

    modal.afterClose.subscribe(() => {
      this.router.navigateByUrl("/home");
    });
  };
}
